<template>
  <div class="letter">
    <div class="content">
      <div class="text" v-if="!isWrite">
        {{ selectedLetter.content }}
      </div>
      <textarea class="text" v-model="selectedLetter.content" v-else></textarea>

      <!-- <div class="mobile-field" v-if="isMobile().any">
        <div class="form-group">
          <label for="title">タイトル</label>
          <input class="form-control" type="text" id="title" v-model="selectedLetter.title">
        </div>
        <div class="form-group">
          <label for="date">送信日</label>
          <input class="form-control" type="date" id="date" v-model="send_date">
        </div>
        <label for="content">内容</label>
        <textarea class="form-control" name="name" rows="8" cols="80" v-model="selectedLetter.content"></textarea>
      </div>
      <div class="pc-field" v-else>
        <table class="table table-bordered">
          <tbody>
            <tr>
              <th>タイトル</th>
              <td>
                <input type="text" class="form-control" v-model="selectedLetter.title">
              </td>
            </tr>
            <tr>
              <th>送信日</th>
              <td>
                <input type="date" class="form-control" :value="send_date" readonly>
              </td>
            </tr>
            <tr>
              <th>内容</th>
              <td>
                <textarea class="form-control" rows="20" cols="80" v-model="selectedLetter.content"></textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <button type="button" class="btn btn-info" name="button">返信</button> -->

    </div>
  </div>
</template>
<script>
import isMobile from 'ismobilejs'

export default {
  name: 'Letter',
  props: {
    selectedLetter: Object,
    isWrite: {
      Boolean,
      default: false
    }
  },
  data(){
    return{
      isMobile
    }
  },
  computed: {
    send_date(){ return this.fixDateToForm(this.selectedLetter.send_date);}
  },
  methods: {
    fixDateToForm(date){
      date = date.toDate();
      let format = 'YYYY-MM-DD';


      format = format.replace(/YYYY/, date.getFullYear());
      let month = ('00' + (date.getMonth()+1)).slice(-2);
      format = format.replace(/MM/, month);
      let day = ('00' + date.getDate()).slice(-2);
      format = format.replace(/DD/, day);


      return format;
    }
  }
}
</script>
<style scoped>
/* .letter {
  width: 100%;
  height: 100%;
} */

@import url('https://fonts.googleapis.com/css2?family=Noto+Serif+JP:wght@500&display=swap');

.letter {
  margin: auto;
  position: relative;
  width: 100%;
  max-width: 70vh;
  /* color: #696969; */
  /* margin: 2em 0; */
  /* font-weight: lighter; */
  border: solid 1px #e6e6e6;
  padding: 0.3em 1em 2em 1em;
  box-shadow:2px 2px 0 rgba(0,0,0,.1);
}
.letter:before{
  content: '';
  display: block;
  padding-top: 120%;
}
.content {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  white-space:pre-wrap;
  word-wrap:break-word;
  /* font-family: inherit; */
  font-family: 'Noto Serif JP', serif;
  overflow: scroll;
}
.text {
  position: relative;
  text-align: left;
  width: 100%;
  min-height: 100%;
  background-size: 100% 2em;
  line-height: 2em;
  padding: 2em 1em 0.2em 1em;
  background-image: linear-gradient(180deg, rgba(100, 100, 100, 0) 0%, rgba(100, 100, 100, 0) 98%, #646464 100%), linear-gradient(to right, #4facfe 0%, #00f2fe 100%);
}
/* #fad0c4 0%, #ffd1ff 100% */

</style>
